const NegotiationFilter = ({
  searchText,
  setSearchText,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  statusFilter,
  setStatusFilter,
  minPrice,
  setMinPrice,
  maxPrice,
  setMaxPrice,
  sliderMax,
  setSliderMax,
  priceRange,
  setPriceRange,
  isManualInput,
  setIsManualInput,
  handleSearch,
  handleReset,
  isHistory = false,
  type = "nego", // "nego" | "sale"
}) => {

  const STATUS_BUTTONS = {
    nego: isHistory
      ? [
          { label: "전체", value: "ALL" },
          { label: "취소", value: "CANCELED" },
          { label: "종료", value: "COMPLETED" },
        ]
      : [
          { label: "전체", value: "ALL" },
          { label: "진행", value: "ONGOING" },
          { label: "대기", value: "UPCOMING" },
        ],
    sale: [
      { label: "전체", value: "ALL" },
      { label: "진행", value: "ONGOING" },
      { label: "대기  ", value: "UPCOMING" },
    ],
  };
  return (
    <div className="negotiation-filter">
      <div className="negotiation-filter-grid">
        <div className="negotiation-filter-column">
          <div className="negotiation-filter-item">
            <label className="negotiation-filter-label">가격</label>
            <div className="negotiation-price-range">
              <div className="negotiation-price-range-buttons">
                <button
                  className={`negotiation-price-range-btn ${priceRange === "all" ? "active" : ""}`}
                  onClick={() => {
                    setPriceRange("all");
                    setSliderMax(100000);
                    setMinPrice(null);
                    setMaxPrice(null);
                    setIsManualInput(false);
                  }}
                >
                  전체
                </button>
                <button
                  className={`negotiation-price-range-btn ${priceRange === "100000" ? "active" : ""}`}
                  onClick={() => {
                    setPriceRange("100000");
                    setSliderMax(100000);
                    setMinPrice(0);
                    setMaxPrice(100000);
                    setIsManualInput(false);
                  }}
                >
                  10만원
                </button>
                <button
                  className={`negotiation-price-range-btn ${priceRange === "200000" ? "active" : ""}`}
                  onClick={() => {
                    setPriceRange("200000");
                    setSliderMax(200000);
                    setMinPrice(0);
                    setMaxPrice(200000);
                    setIsManualInput(false);
                  }}
                >
                  20만원
                </button>
                <button
                  className={`negotiation-price-range-btn ${priceRange === "300000" ? "active" : ""}`}
                  onClick={() => {
                    setPriceRange("300000");
                    setSliderMax(300000);
                    setMinPrice(0);
                    setMaxPrice(300000);
                    setIsManualInput(false);
                  }}
                >
                  30만원
                </button>
                <button
                  className={`negotiation-price-range-btn ${priceRange === "500000" ? "active" : ""}`}
                  onClick={() => {
                    setPriceRange("500000");
                    setSliderMax(500000);
                    setMinPrice(0);
                    setMaxPrice(500000);
                    setIsManualInput(false);
                  }}
                >
                  50만원
                </button>
                <button
                  className={`negotiation-price-range-btn ${priceRange === "1000000" ? "active" : ""}`}
                  onClick={() => {
                    setPriceRange("1000000");
                    setSliderMax(1000000);
                    setMinPrice(0);
                    setMaxPrice(1000000);
                    setIsManualInput(false);
                  }}
                >
                  100만원
                </button>
                <button
                  className={`negotiation-price-range-btn ${priceRange === "custom" ? "active" : ""}`}
                  onClick={() => {
                    setPriceRange("custom");
                    setIsManualInput(true);
                  }}
                >
                  직접 입력
                </button>
              </div>

              <div className="negotiation-price-inputs">
                <input
                  type="number"
                  value={priceRange === "all" ? "" : minPrice}
                  onChange={(e) => {
                    const value = Math.min(Math.max(0, Number(e.target.value)), maxPrice);
                    setMinPrice(value);
                    if (isManualInput) {
                      const newMax = Math.max(value, maxPrice);
                      setSliderMax(Math.max(newMax, 10000));
                    }
                  }}
                  className="negotiation-price-input"
                  placeholder="최소가"
                  onFocus={(e) => e.target.select()}
                  disabled={priceRange === "all" || !isManualInput}
                />
                <span>~</span>
                <input
                  type="number"
                  value={priceRange === "all" ? "" : maxPrice}
                  onChange={(e) => {
                    const value = Math.max(minPrice, Number(e.target.value));
                    setMaxPrice(value);
                    if (isManualInput) {
                      setSliderMax(Math.max(value, 10000));
                    }
                  }}
                  className="negotiation-price-input"
                  placeholder="최대가"
                  onFocus={(e) => e.target.select()}
                  disabled={priceRange === "all" || !isManualInput}
                />
                <span className="negotiation-price-unit">원</span>
              </div>

              <div className="negotiation-price-slider-wrapper">
                <div className="negotiation-price-slider-container" style={{ opacity: (isManualInput || priceRange === "all") ? 0.4 : 1 }}>
                  <div 
                    className="negotiation-price-slider-track-active"
                    style={{
                      left: `${(minPrice / sliderMax) * 100}%`,
                      width: `${((maxPrice - minPrice) / sliderMax) * 100}%`
                    }}
                  />
                  <input
                    type="range"
                    min="0"
                    max={sliderMax}
                    step="1000"
                    value={minPrice}
                    onChange={(e) => {
                      const value = Math.min(Number(e.target.value), maxPrice);
                      setMinPrice(value);
                    }}
                    className="negotiation-price-slider negotiation-price-slider-min"
                    disabled={isManualInput}
                  />
                  <input
                    type="range"
                    min="0"
                    max={sliderMax}
                    step="1000"
                    value={maxPrice}
                    onChange={(e) => {
                      const value = Math.max(Number(e.target.value), minPrice);
                      setMaxPrice(value);
                    }}
                    className="negotiation-price-slider negotiation-price-slider-max"
                    disabled={isManualInput || !isManualInput}
                    style={{ visibility: isManualInput ? 'visible' : 'hidden' }}
                  />
                </div>
                <div className="negotiation-price-ticks">
                  <span className="negotiation-price-tick">0</span>
                  <span className="negotiation-price-tick">{(sliderMax * 0.2 / 10000).toFixed(0)}만</span>
                  <span className="negotiation-price-tick">{(sliderMax * 0.4 / 10000).toFixed(0)}만</span>
                  <span className="negotiation-price-tick">{(sliderMax * 0.6 / 10000).toFixed(0)}만</span>
                  <span className="negotiation-price-tick">{(sliderMax * 0.8 / 10000).toFixed(0)}만</span>
                  <span className="negotiation-price-tick">{(sliderMax / 10000).toFixed(0)}만</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="negotiation-filter-column">
          <div className="negotiation-filter-item">
            <label className="negotiation-filter-label">기간</label>
            <div className="negotiation-date-range-inner">
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
          </div>

          <div className="negotiation-filter-item">
            <label className="negotiation-filter-label">상태</label>
            <div className="negotiation-status-filter">
              {STATUS_BUTTONS[type].map(({ label, value }) => (
                <button
                  key={value}
                  className={`negotiation-status-btn ${statusFilter === value ? "active" : ""}`}
                  onClick={() => setStatusFilter(value)}
                >
                  {label}
                </button>
              ))}
            </div>
          </div>

          <div className="negotiation-filter-item">
            <label className="negotiation-filter-label">상품명</label>
            <input
              type="text"
              placeholder="상품명을 입력해주세요"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              className="negotiation-search-input"
            />
          </div>

          <div className="negotiation-filter-item">
            <label className="negotiation-filter-label"></label>
            <div className="negotiation-filter-actions" style={{ justifyContent: 'flex-end', width: '100%' }}>
              <button className="negotiation-btn primary" onClick={handleSearch}>검색</button>
              <button className="negotiation-btn" onClick={handleReset}>초기화</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NegotiationFilter;
